<template>
    <div>
<div class="inputControl">
     <label :class="{ lblname : showBordernal }">Nueva Contraseña<span>*</span></label>
     <input v-if="showPassword" type="text" class="form-control" v-model="Pass" />
     <input v-else  type="password" placeholder="Contraseña" name="Pass" id="Pass" class="form-control" autocomplete="nope" maxlength="500" minlength="3"
     :class="{ bodernamenal : showBordernal }"
     oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" required  v-model="Pass">
     </div> 
     <button  @click="toggleShow" style="background-color:transparent;border-style:none;margin-top:0">Mostrar Contraseña</button>
     <p><b>
        La contraseña debe tener al menos 8 caracteres de longitud e incluir letras en minúsculas y mayúsculas, un número y un símbolo
    
     </b>
         </p> 
     <span style="color:#b11026 !important; text-align: left;" :class="{ spannal : showSpannal }">{{textn }}</span>
     <div class="inputControl">
     <label :class="{ lblname : showBordernal }">Confirmar Contraseña<span>*</span></label>
     <input v-if="showPasswordos" type="text" class="form-control" v-model="Passc" />
     <input v-else  type="password" placeholder="Contraseña" name="Passc" class="form-control" autocomplete="nope" maxlength="500" minlength="3"
     :class="{ bodernamenal : showBordernal }"
     oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" required  v-model="Passc">
     </div>  
     <button  @click="toggleShowdos" style="background-color:transparent;border-style:none;margin-top:0">Mostrar Contraseña</button>
     <span style="color:#b11026 !important; text-align: left;" :class="{ spannal : showSpannal }">{{textn }}</span>
</div>

    
    </template>
    <style scoped>
    .lblname{
        color: #b11026;
    }
    .spannal {
       display: none;
    }
    .bodernamenal{
       border:1px solid #b11026;
    }
    .spanapal {
       display: none;
    }
    .boderapnal{
       border:1px solid #b11026;
    }
    .spanamal {
       display: none;
    }
    .boderamnal{
        border:1px solid #b11026;
    }
    .spantlal {
       display: none;
    }
    .boderatlal{
        border:1px solid #b11026;
    }
    .spantlcal {
       display: none;
    }
    .boderatlcal{
       border:1px solid #b11026;
    }
    .spancoal {
       display: none;
    }
    .boderacoal{
        border:1px solid #b11026;
        
    }
    .cardForm {
    
      border-radius: 6px;
      box-shadow: 0 11px 24px 0 #b0d3eb;
      border: solid 1px #5eabe0;
      background-color: white;
      border-top: solid 8px #0d6eba;
      padding: 24px;
      width: 40%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 45px;
      
      
      }
      @media only screen and (max-width: 880px) {
          .cardForm {
            width: 80%;
          }
      }
    
    .inputControl {
      position: relative;
       margin-top: 30px;
        display: flex;
    }
    label {
        color: black;
        background: white;
        font-size: 14px;
        font-weight: bold;
        position: absolute;
        top: -9px;
        left: 9px;
        padding: 0 8px;
      }
    
      input {
        border-radius: 6px;
        border: solid 1px black;
        background-color: white;
        padding: 10px 16px;
        padding-right: 35px;
        width: 100%;
        font-size: 16px;
        color:  #505050;
    
      
      }
    
       button {
        width: 100%;
        margin-top: 20px;
        text-align: center;
      }
    
       h2 {
          margin-top: 5px;
          margin-bottom: 25px;
          color:#0d6eba;
          font-weight:700;
          font-size:24px;
        }
        .cmp-button{
            appearance:none;
            border-radius: 3px;
            cursor:pointer;
            font-size:18px;
            padding:9pt 14px 14px;
            text-align:center;
            font-weight:500;
            background-color:#f68b1f;
            border: 1px solid #f68b1f;
            color:#003053!important;
            transition:background-color .4s ease-out,color .3s ease-out,border .4s ease-out;
        }
    </style>
    <script>
    import axios from 'axios';
    export default {
        props:['correo'],   
         watch: {
            Passc: function() {
          // Emit this information to the parents component
          this.$emit("datageneralalumno", {pass:this.Pass,passc:this.Passc});
        }
        },
         data(){
            return{
                showPassword: false,
                showPasswordos: false,
                showSpannal: true,
                showBordernal: false,
    
                showSpanapal: true,
                showBorderapal: false,
    
                showSpanamal: true,
                showBorderamal: false,
    
                showSpantlal: true,
                showBordertlal: false,
    
                showSpantlcal: true,
                showBordertlcal: false,
    
                showSpancoal: true,
                showBordercoal: false,
    
                Pass:'',
                Passc:'',
                ApellidoPaterno:'',
                ApellidoMaterno:'',
                CorreoElectronico:'',
                Telefono:'',
                TelefonoCasa:'',
                Turno:'',
    
                textn:'',
                textap:'',
                textam:'',
                textem:'',
                texttc:'',
                texttel:'',
                disablePhone:false,
                disablePhone2:false,
                disableMail:false,
                url:process.env.VUE_APP_URL,
                urlgeneral:process.env.VUE_APP_URL_GENERAL,
                urlpost:process.env.VUE_APP_URL_POST
            }
        },
        mounted() { 
            this.getTypesch();
        },
      methods: {
        toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShowdos() {
      this.showPasswordos = !this.showPasswordos;
    },
        getTypesch(){
this.CorreoElectronico =this.correo;
        },
       notEmptygeneral() {
       var correo = this.CorreoElectronico;
       var telefono = this.Telefono; 
       var telefono2 = this.TelefonoCasa; 
    
       if(telefono == "" && telefono2 == "" && correo == ""){
        this.disableMail = true;
        this.disablePhone = true;
        this.disablePhone2 = true;
       }
         },
         notEmptytlcal(e) {
        var telefono2 = this.TelefonoCasa; 
        var telefono = this.Telefono; 
    
        var turno = this.Turno; 
    
        if(turno != ""){
           this.Turno = ""
        }
    
       if(telefono2 == "" && telefono == ""){
        this.disableMail = true;
       }
    
       else{
        this.disablePhone = false; 
        this.disableMail = false; 
       }
    
         var inputvalue = e.target.value;
         var stringReal = e.target.value.split("");
         var permitidos = 6;
         var stringNum = "";
         stringNum += e.target.value + e.key;
         var matches = stringNum.match(/([0-9])\1*/g) || [];
         var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
    
         if (inputvalue === '') {
            this.showSpantlcal = false;
            this.showBordertlcal = true;
            this.texttel = 'El teléfono local no puede estar vacío';
         }
         else if(stringReal[0] == 0 || e.keyCode == 101 || e.keyCode == 45 || e.keyCode == 43 || e.keyCode == 46){
                this.showSpantlcal = false;
                this.showBordertlcal = true;
                this.texttel = 'El teléfono local no puede comenzar con cero o con un valor especial';
                this.TelefonoCasa = '';
                e.preventDefault();
         }
        else if(lastInput >= permitidos){
                this.showSpantlcal = false;
                this.showBordertlcal = true;
                this.texttel = 'No se deben capturar números con 6 dígitos iguales';
                this.TelefonoCasa = '';
         }
         else{
                var url= this.urlpost+"/GetCofetelValidation?numero_telefono="+inputvalue;
                axios.get(url)
                .then(response => {
                let dataDummy = response.data;
                var respuesta = dataDummy.Respuesta;
                if(respuesta === false){
                this.showSpantlcal = false;
                this.showBordertlcal = true;
                this.texttel = 'El teléfono local es inválido';
                this.TelefonoCasa = '';
                e.preventDefault();
                    }
    
                    else{
                const url =this.urlgeneral+"/json/telefonosBasura.min.json";
        axios.get( url )
        .then(response => {
        const products = response.data;
        var a = products.filter(a => a.includes(inputvalue));
        var numero = a;
        if(numero == ""){
        this.showSpantlcal = true;
        this.showBordertlcal = false; 
        }
        else{
         this.showSpantlcal = false;
        this.showBordertlcal = true;
        this.texttel = 'Teléfono inválido';
        this.TelefonoCasa = ''; 
        }
     
     });
                    }
                });
         } 
    },
         notEmptytlal(e) {
         var inputvalue = e.target.value;
         var stringReal = e.target.value.split("");
         var permitidos = 6;
         var stringNum = "";
         stringNum += e.target.value + e.key;
         var matches = stringNum.match(/([0-9])\1*/g) || [];
         var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
    
        var telefono = this.Telefono;
        var telefono2 = this.TelefonoCasa; 
    
        var turno = this.Turno; 
    
        if(turno != ""){
           this.Turno = ""
        }
    
       if(telefono == "" && telefono2 == ""){
          this.disableMail = true;
          this.disablePhone2 = true;
       }
       else{
           this.disableMail = false;
           this.disablePhone2 = false; 
       }
    
    
         if (inputvalue === '') {
            this.showSpantlal = false;
            this.showBordertlal = true;
            this.texttc = 'El celular no puede estar vacío';
         }
         else if(stringReal[0] == 0 || e.keyCode == 101 || e.keyCode == 45 || e.keyCode == 43 || e.keyCode == 46){
                this.showSpantlal = false;
                this.showBordertlal = true;
                this.texttc = 'El celular no puede comenzar con cero o con un valor especial';
                this.Telefono = '';
                e.preventDefault();
         }
        else if(lastInput >= permitidos){
                this.showSpantlal = false;
                this.showBordertlal = true;
                this.texttc = 'No se deben capturar números con 6 dígitos iguales';
                this.Telefono = '';
         }
         else{
                var url= this.urlpost+"/GetCofetelValidation?numero_telefono="+inputvalue;
                axios.get(url)
                .then(response => {
                let dataDummy = response.data;
                var respuesta = dataDummy.Respuesta;
                if(respuesta === false){
                this.showSpantlal = false;
                this.showBordertlal = true;
                this.texttc = 'El celular es inválido';
                this.Telefono = '';
                e.preventDefault();
                    }
    
                    else{
               const url =this.urlgeneral+"/json/telefonosBasura.min.json";
        axios.get( url )
        .then(response => {
        const products = response.data;
        var a = products.filter(a => a.includes(inputvalue));
        var numero = a;
        if(numero == ""){
        this.showSpantlal = true;
        this.showBordertlal = false; 
        }
        else{
         this.showSpantlal = false;
        this.showBordertlal = true;
        this.texttc = 'Teléfono inválido';
        this.Telefono = '';
        }
     
     });
                    }
                });
         }
    },
         notEmptyamal(e) {
        var inputvalue = e.target.value;
        var onlyVowels = false;
        var oneVowel = false;
        var oneConsonante = false;
           var onlyConsonantes = false;
           var permitidos = 2;
        onlyVowels = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú]){3}/g) !== null;
        onlyConsonantes = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ]){4}/g) !== null;
        oneVowel = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])/g) === null;
        oneConsonante = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])/g) === null;
        //consulta del campus basura
    
       const url =this.urlgeneral+"/api/jsonBasura";
        axios.get( url )
        .then(response => {
        const products = response.data;
        for (var i in products){
        if (inputvalue.search(products[i].crmit_name) !== -1 || inputvalue.search(products[i].crmit_name) !== -1) {
        this.showSpanamal = false;
        this.showBorderamal = true;
        this.textam = 'El valor (valor capturado) es un dato incorrecto';
        this.ApellidoMaterno= '';
        }
        }
        });
    
         if (inputvalue === '') {
            this.textam = 'No puede estar vacío el campo Pass Apellido Materno Alumno';
            this.showSpanamal = false;
            this.showBorderamal = true;
         }
     
         else if (onlyVowels && oneConsonante) {
            this.showSpanamal = false;
            this.showBorderamal = true;
            this.textam = 'No se puede ingresar puras consonantes o puras vocales';
            this.ApellidoMaterno = '';
        }
    
        else if (onlyConsonantes && oneVowel) {
            this.showSpanamal = false;
            this.showBorderamal = true;
            this.textam = 'No se puede ingresar puras consonantes o puras vocales';
            this.ApellidoMaterno = '';
        }
    
          else if (inputvalue.length <= permitidos) {
            this.showSpanamal = false;
            this.showBorderamal = true;
            this.textam = 'El campo no cumple con la longitud mínima requerida';
            this.ApellidoMaterno= '';
         }
         
         else{
            var Pass= this.ApellidoMaterno;
            this.ApellidoMaterno = Pass.trim();
            this.showSpanamal = true;
            this.showBorderamal = false;
         }
    },
         notEmptyapal(e) {
        var inputvalue = e.target.value;
        var permitidos = 2;
        var onlyConsonantes = false;
        var onlyVowels = false;
        var oneVowel = false;
        var oneConsonante = false;
        onlyVowels = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú]){3}/g) !== null;
        onlyConsonantes = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ]){4}/g) !== null;
        oneVowel = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])/g) === null;
        oneConsonante = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])/g) === null;
        //consulta del campus basura
    
       const url =this.urlgeneral+"/api/jsonBasura";
        axios.get( url )
        .then(response => {
        const products = response.data;
        for (var i in products){
        if (inputvalue.search(products[i].crmit_name) !== -1 || inputvalue.search(products[i].crmit_name) !== -1) {
        this.showSpanapal = false;
        this.showBorderapal = true;
        this.textap = 'El valor (valor capturado) es un dato incorrecto';
        this.ApellidoPaterno = '';
        }
        }
        });
    
         if (inputvalue === '') {
            this.textap = 'No puede estar vacío el campo Pass Apellido Paterno Alumno';
            this.showSpanapal = false;
            this.showBorderapal = true;
         }
         
        else if (onlyVowels && oneConsonante) {
            this.showSpanapal = false;
            this.showBorderapal = true;
            this.textap = 'No se puede ingresar puras consonantes o puras vocales';
            this.ApellidoPaterno = '';
        }
    
        else if (onlyConsonantes && oneVowel) {
            this.showSpanapal = false;
            this.showBorderapal = true;
            this.textap = 'No se puede ingresar puras consonantes o puras vocales';
            this.ApellidoPaterno = '';
        }
    
          else if (inputvalue.length <= permitidos) {
            this.showSpanapal = false;
            this.showBorderapal = true;
            this.textap = 'El campo no cumple con la longitud mínima requerida';
            this.ApellidoPaterno= '';
         }
         
         else{
            var Pass= this.ApellidoPaterno;
            this.ApellidoPaterno = Pass.trim();
            this.showSpanapal = true;
            this.showBorderapal = false;
         }
    },
         notEmptyna(e) {
         var inputvalue = e.target.value;
        var permitidos = 2;
        var onlyConsonantes = false;
        var onlyVowels = false;
        var oneVowel = false;
        var oneConsonante = false;
        onlyVowels = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú]){3}/g) !== null;
        onlyConsonantes = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ]){4}/g) !== null;
        oneVowel = inputvalue.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])/g) === null;
        oneConsonante = inputvalue.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])/g) === null;
        //consulta del campus basura
    
       const url =this.urlgeneral+"/api/jsonBasura";
        axios.get( url )
        .then(response => {
        const products = response.data;
        for (var i in products){
        if (inputvalue.search(products[i].crmit_name) !== -1 || inputvalue.search(products[i].crmit_name) !== -1) {
        this.showSpannal = false;
        this.showBordernal = true;
        this.textn = 'El valor (valor capturado) es un dato incorrecto';
        this.Pass = '';
        }
        }
        });
    
         if (inputvalue === '') {
            this.textn = 'No puede estar vacío el campo Pass Alumno';
            this.showSpannal = false;
            this.showBordernal = true;
         }
        
        else if (onlyVowels && oneConsonante) {
            this.showSpannal = false;
            this.showBordernal = true;
            this.textn = 'No se puede ingresar puras consonantes o puras vocales';
            this.Pass = '';
        }
    
        else if (onlyConsonantes && oneVowel) {
            this.showSpannal = false;
            this.showBordernal = true;
            this.textn = 'No se puede ingresar puras consonantes o puras vocales';
            this.Pass = '';
        }
    
          else if (inputvalue.length <= permitidos) {
            this.showSpannal = false;
            this.showBordernal = true;
            this.textn = 'El campo no cumple con la longitud mínima requerida';
            this.Pass= '';
         }
         
         else{
            var Pass= this.Pass;
            this.Pass = Pass.trim();
            this.showSpannal = true;
            this.showBordernal = false;
         }
        }
    ,
         notEmpty(e) {
         var inputvalue = e.target.value;
         if (inputvalue === '') {
                alert("El campo no puede estar vacío");
         }
         else{
             //console.log("no esta entrando al if"); 
         }
         //console.log(inputvalue);
    },
    notEmptytest(){
    
    },
     notEmptyEmail(e) {
        var inputvalue = e.target.value;
        var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        let arrEmail = inputvalue.split('@');
        let lenUser = arrEmail[0].length;
        var email = this.CorreoElectronico;
        var turno = this.Turno; 
        if(turno != ""){
           this.Turno = ""
        }
        if(email == ""){
        this.disablePhone = true;
        this.disablePhone2 = true;
        }
        else{
           this.disablePhone = false;
           this.disablePhone2 = false; 
        }
        if (inputvalue == '') {
                //alert("El campo no puede estar vacio");
             this.showSpancoal = false;
            this.showBordercoal = true;
            this.textem  = 'El correo no puede estar vacío';
           //console.log("if vacio");
        }
        else{
        if (!emailRegex.test(inputvalue)) {
        this.showSpancoal = false;
         this.showBordercoal = true;
         this.textem  = 'El correo no contiene una estructura válida';
         this.CorreoElectronico = '';
         //console.log("if regex");
        }
        else{
        var arrDominio = arrEmail[1].split('.');
        var arrLargo = arrDominio.length;
        axios.get( this.urlgeneral+'/json/json_basuraEmail.min.json' )
                .then(response => {
        localStorage.emailBasura = JSON.stringify(response.data);
        let jsonBasura = JSON.parse(localStorage.emailBasura);
        for (var x = 0; x <= arrLargo - 2; x++) {
        //esta vacio el Pass del dominio o subdominio?
         //console.log("dominio "+x+"Pass de dominio"+arrDominio[x]);
        if (arrDominio[x] === "") {
        this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Correo inválido';
        this.CorreoElectronico = ''; 
        //es muy largo o muy corto el Pass del dominio?
        }else if (arrDominio[x].length > 36 || arrDominio[x].length < 1) {
        this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Correo inválido';
        this.CorreoElectronico = ''; 
        }
        //Validación de correo basura en el dominio
        if (Object.keys(jsonBasura).length != 0) {
       //Primer if json basura.lenght
        for (var i = 0; i < Object.keys(jsonBasura).length; i++) {
           console.log('Buscando Errore en usuario');
                                console.log(arrEmail[0]);
                                if (arrEmail[0]==jsonBasura[i]) {
                                    console.log('El error entro aqui');
                                    console.log(jsonBasura[i]);
                            this.showSpancoal = false;
                            this.showBordercoal = true;
                            this.textem = 'Correo inválido';
                            this.CorreoElectronico = ''; 
                                }
                                console.log('Preguntando por no valido '+arrEmail[1]+' '+ arrEmail[1].indexOf('novalido'));
                                if (arrEmail[0].indexOf('novalido') != -1) {
                                    console.log('El error entro aqui');
                                    console.log(jsonBasura[i]);
                                    this.showSpancoal = false;
                            this.showBordercoal = true;
                            this.textem = 'Correo inválido';
                            this.CorreoElectronico = ''; 
                                }
        }
        }
       //Validacion del dominio
       axios.get( this.urlgeneral+'/json/json_basuraDomain.min.json' )
                .then(response => {
       localStorage.dominioBasura = JSON.stringify(response.data);
       let dominioBasura = JSON.parse(localStorage.dominioBasura);
       if (Object.keys(dominioBasura).length != 0) {
                            for (var i = 0; i < Object.keys(dominioBasura).length; i++) {
                                console.log('Buscando Errore en Dominio');
                                console.log(arrEmail[1]);
                         console.log(dominioBasura[i]);
                                if (arrEmail[1]==dominioBasura[i].toUpperCase()) {
                                    console.log('El error entro aqui');
                                    console.log(dominioBasura[i]);
                                    this.showSpancoal = false;
                            this.showBordercoal = true;
                            this.textem = 'Dominio inválido';
                            this.CorreoElectronico = ''; 
                                }
                                console.log('Preguntando por no valido '+arrEmail[1]+' '+ arrEmail[1].indexOf('novalido'));
                                if (arrEmail[1].indexOf('novalido') != -1) {
                                    console.log('El error entro aqui');
                                    console.log(dominioBasura[i]);
                                    this.showSpancoal = false;
                            this.showBordercoal = true;
                            this.textem = 'Dominio inválido';
                            this.CorreoElectronico = '';
                                }
                            }
                        }
    });
    
        }
    });
    
       
     if (arrDominio[arrLargo - 1] === "") {
            
         this.showSpancoal = false;
         this.showBordercoal = true;
         this.textem = 'Longitud de correo inválida';
         this.CorreoElectronico = '';
        } 
    
     
    
        else if (arrDominio[arrLargo - 1].length >= 4 || arrDominio[arrLargo - 1].length <= 1) {
         this.showSpancoal = false;
         this.showBordercoal = true;
         this.textem = 'Longitud de correo inválida';
         this.CorreoElectronico = '';
        }
    
        else if (lenUser <= 2 || lenUser > 100) {
         this.showSpancoal = false;
         this.showBordercoal = true;
         this.textem = 'Longitud de correo inválida';
         this.CorreoElectronico = '';
        }
    
        else if (arrEmail[1].search(/(hotmail|outlook|live)/i) != -1 && (
        arrEmail[0][0].search(/(-|_|\.|[0-9])/) != -1 || arrEmail[0].search(/\.{2}/g) != -1)) {
        this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Ingrese un correo válido';
        this.CorreoElectronico = '';
        }
    
    
        else if (arrEmail[1].search(/gmail/i) != -1 && (arrEmail[0][lenUser - 1].search(/[^a-zA-Z0-9]/) != -1 || arrEmail[0].search(/\.{2}/g) != -1 || arrEmail[0].search(/(-|_)/g) != -1)) {
         this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Ingrese un correo válido';
        this.CorreoElectronico = '';     
        }
    
        else if (arrEmail[1].search(/yahoo/i) != -1 && (arrEmail[0][lenUser - 1].search(/[^a-zA-Z0-9]/) != -1 || arrEmail[0][0].search(/(_|\.|[0-9])/) != -1 || arrEmail[0].search(/(\.|_){2}/g) != -1 || arrEmail[0].search(/-/g) != -1)) {
        this.showSpanco2 = false;
        this.showBorderco = true;
        this.textcorreo = 'Ingrese un correo válido';
        this.form.CorreoElectronico = '';                                 
        }
    
        else if (arrEmail[1].search(/(^hotmail|outlook|gmail|live|yahoo|unitec)/i) == -1 && (arrEmail[0][lenUser - 1].search(/(-|_|\.)/) != -1 || arrEmail[0][0].search(/(-|_|\.|[0-9])/) != -1 || arrEmail[0].search(/(-|_|\.){2}/g) != -1)) {
        this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Ingrese un correo válido';
        this.CorreoElectronico = '';       
        }
    
          //Validamos que no existen caracteres especiales en el Pass de usuario
        else if (arrEmail[0].search(/[^a-zA-Z0-9_.-]/) != -1) {
        this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Caracter inválido encontrado';
        this.CorreoElectronico = ''; 
        }
    
        else if (arrEmail[1].search(/[^a-zA-Z0-9_.-]/) != -1) {
        this.showSpancoal = false;
        this.showBordercoal = true;
        this.textem = 'Caracter inválido encontrado';
         this.CorreoElectronico = '';
        }
    
        
            //console.log("else");
            this.showSpancoal = true;
            this.showBordercoal = false;
             this.textem  = ''
         
         //console.log("bandera 4");
        }
        }
    },
         notEmptyNumber(e) {
         var inputvalue = e.target.value;
         var inputlenght = e.target.value.length;
         if(inputlenght<3){
         alert("El numero tiene que estar compuesto por 10 dígitos");
         }
         if (inputvalue === '') {
                alert("El campo no puede estar vacío");
         }
         else{
             //console.log("no esta entrando al if"); 
         }
         //console.log(inputvalue);
    },
    
       forceUppercase(e) {
         e.value = e.value.toUpperCase();
        },
    
         isLetter(e) {
           var permitidos = 3;
        var stringNum = "";
        stringNum += e.target.value + e.key;
        var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
        var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
        var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
        var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
        
        if (lastInput === permitidos || lastInputConsonantes === permitidos) {
             this.showSpannal = false;
            this.showBorderna = true;
            this.textn = 'No se permiten ingresar 3 letras Consecutivas';
            e.preventDefault();  
        }
        var stringReal = e.target.value.split("");
        if (stringReal[0] == " " || stringReal[0] == 32) {
        this.showSpannal = false;
        this.showBorderna = true;
        this.textn = 'No se permiten espacios vacíos al inicio';
        e.preventDefault();
        }
    
        let char = String.fromCharCode(e.keyCode); // Get the character
         if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
        
    
         else e.preventDefault(); // If not match, don't add to input text
         },
              isLetterap(e) {
           var permitidos = 3;
        var stringNum = "";
        stringNum += e.target.value + e.key;
        var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
        var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
        var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
        var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
        
        if (lastInput === permitidos || lastInputConsonantes === permitidos) {
             this.showSpanapal = false;
            this.showBorderapal = true;
            this.textap = 'No se permiten ingresar 3 letras Consecutivas';
            e.preventDefault();  
        }
        var stringReal = e.target.value.split("");
        if (stringReal[0] == " " || stringReal[0] == 32) {
        this.showSpanapal = false;
        this.showBorderapal = true;
        this.textap = 'No se permiten espacios vacíos al inicio';
        e.preventDefault();
        }
    
        let char = String.fromCharCode(e.keyCode); // Get the character
         if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
        
    
         else e.preventDefault(); // If not match, don't add to input text
         },
              isLetteram(e) {
           var permitidos = 3;
        var stringNum = "";
        stringNum += e.target.value + e.key;
        var matches = stringNum.match(/([aeiouAEIOUÁáÉéÍíÓóÚú])\1*/ig) || [];
        var matchesConsonantes = stringNum.match(/([b-df-hj-np-tv-zB-DF-HJ-NP-TV-Z-Ññ])\1*/ig) || [];
        var lastInput = matches.length > 0 ? matches[matches.length - 1].length : 0;
        var lastInputConsonantes = matchesConsonantes.length > 0 ? matchesConsonantes[matchesConsonantes.length - 1].length : 0;
        
        if (lastInput === permitidos || lastInputConsonantes === permitidos) {
             this.showSpanamal = false;
            this.showBorderamal = true;
            this.textam = 'No se permiten ingresar 3 letras Consecutivas';
            e.preventDefault();  
        }
        var stringReal = e.target.value.split("");
        if (stringReal[0] == " " || stringReal[0] == 32) {
        this.showSpanamal = false;
        this.showBorderamal = true;
        this.textam = 'No se permiten espacios vacíos al inicio';
        e.preventDefault();
        }
    
        let char = String.fromCharCode(e.keyCode); // Get the character
         if(/^[A-Za-z-Ññ\s]+$/.test(char)) return true; // Match with regex 
        
    
         else e.preventDefault(); // If not match, don't add to input text
         },
    }
    }
    </script>